import { colorVar } from './jlfcTheme';

/** Styles Mantine Select/Input quand un critère de filtre est actif. */
export function activeFilterStyles(isActive) {
  if (!isActive) return undefined;
  return {
    label: { fontWeight: 700, color: colorVar(7) },
    input: {
      borderColor: colorVar(5),
      backgroundColor: colorVar(0),
    },
  };
}

export const FILTER_WIDTH_NARROW = 160;
export const FILTER_WIDTH_WIDE = 280;
export const FILTER_WIDTH_STATUT = 240;
export const FILTER_WIDTH_EMAIL = 240;
export const FILTER_WIDTH_RELANCE = 240;

export function isWideFilter(filter) {
  return filter?.key === 'client_label' || filter?.wide === true;
}

export function resolveFilterWidth(filter) {
  if (filter?.width) return filter.width;
  return isWideFilter(filter) ? FILTER_WIDTH_WIDE : FILTER_WIDTH_NARROW;
}
